import React from 'react';
import ReactDOM from 'react-dom';

import Types from './common/Types.jsx';
import './layout/Page.jsx';

// globalThis polyfill for Safari <12.1 / Edge Legacy / Chrome <71
if (typeof globalThis === 'undefined') {
    (typeof self !== 'undefined' ? self : window).globalThis =
        typeof self !== 'undefined' ? self : window;
}

globalThis.React = React;
globalThis.ReactDOM = ReactDOM;
globalThis.Components = Types.Block.getAllComponents();